import { useEffect, useState } from "react";
import { useTheme } from "../../../contexts/theme";
import "./ThemePreference.css";
import { useAuth } from "../../../contexts/auth";
import Form from "../../../components/Form/Form";
import Select from "../../../components/Select/Select";
import Spacer from "../../../components/Spacer/Spacer";
import { useUserStore } from "../../../contexts/userStore";
import UserService from "../../../services/UserService";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/Loader/Loader";

export function ThemePreference(props) {
	const { user, storeUser } = useAuth();
	const { getUrlPreference } = useUserStore();
	const navigate = useNavigate();
	const [theme, setTheme] = useState("classic");
	const { changeTheme } = useTheme();
	const [showLoader, setShowLoader] = useState(false);

	useEffect(() => {
		const themePreference = user?.userData?.theme ?? user?.userData?.selectedOrganization?.defaultTheme ?? 'black';
		setTheme(themePreference);
		changeTheme(themePreference);
	}, [user]);

	async function updateTheme(event) {
		event.preventDefault();
		let response = {};
		response = await UserService.updateTheme(theme);
		setShowLoader(false);

		if (response.status !== 200) return;
		changeTheme(theme);
		storeUser({
			userData: {
				...user.userData,
				theme,
			}
		});
		navigate(getUrlPreference());
	}

	return (
		<>
			{showLoader ? (
				<Loader style={{ marginTop: '0px' }} />
			) : (
				<Form
					handleSubmit={updateTheme}
					navigateCancelUrl={getUrlPreference()}
				>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							width: "350px",
							maxWidth: "100%"
						}}
					>
						<p className="edit-profile-title-details">
							Atualizar cores do sistema
						</p>
						<Select
							labelText="Tema"
							name="theme"
							id="theme"
							value={theme}
							onChange={({ target }) => setTheme(target.value)}
							options={[
								{ value: "classic", text: "Modo Claro" },
								{ value: "black", text: "Modo Escuro" },
							]}
						/>
						<Spacer marginTop="15" />
					</div>
				</Form>
			)}
		</>
	);
}